import { Box, type SxProps } from '@mui/material';
import type { FC } from 'react';

interface IconProps {
  src: string;
  height?: string;
  width?: string;
  sx?: SxProps;
}

export const Icon: FC<IconProps> = ({ src, height, width, sx }) => {
  return (
    <Box
      component='img'
      src={src}
      sx={{
        height,
        width,
        ...sx,
      }}
    />
  );
};
